module.exports = __webpack_public_path__ + "src/app/settings/personalSettings/icons/convious-pattern@2x.png?7ab583280c3312ecea93f21a0cef66b2";